export enum TransferMode {
  Sync = 'SYNC',
  Copy = 'COPY',
  Move = 'MOVE',
}
